import { render } from "./instant.vue?vue&type=template&id=17857e8c"
import script from "./instant.vue?vue&type=script&lang=js"
export * from "./instant.vue?vue&type=script&lang=js"

import "./instant.vue?vue&type=style&index=0&id=17857e8c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__